//https://logaretm.github.io/vee-validate/guide/3rd-party-libraries.html#bootstrapvue
//https://logaretm.github.io/vee-validate/guide/rules.html#importing-rules-in-nuxt-js
//https://codesandbox.io/s/veevalidate-components-vuetify-pij6w?from-embed
// Vue.use(VeeValidate)
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import Vue                                                from 'vue'
import * as rules                                         from 'vee-validate/dist/rules';
import { messages }                                       from 'vee-validate/dist/locale/pt_BR.json';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule], // copies rule configuration
        message: messages[rule] // assign message
    });
});

//https://logaretm.github.io/vee-validate/guide/basics.html#messages
extend('cnpj', {
    validate: value => {
        // return value % 2 !== 0;
        function validarCNPJ (cnpj) {
            let resultado, tamanho, numeros, digitos, soma, pos;
            cnpj = cnpj.replace(/[^\d]+/g, '');
            if (cnpj == '') return false;
            
            if (cnpj.length != 14) {
                return false;
            }
            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999") {
                return false;
            }
            // Valida DVs
            tamanho = cnpj.length - 2
            numeros = cnpj.substring(0, tamanho);
            digitos = cnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) {
                    pos = 9;
                }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) {
                return false;
            }
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) {
                    pos = 9;
                }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) {
                return false;
            }
            return true;
        }
        
        if (validarCNPJ(value)) {
            return true;
        }
        return 'O campo "{_field_}" não é reconhecido como válido';
    }
});
extend('cpf', {
    validate: value => {
        // return value % 2 !== 0;
        function validarCPF (cpf) {
            let add, rev;
            cpf = cpf.replace(/[^\d]+/g, '');
            if (cpf == '') return false;
            // Elimina CPFs invalidos conhecidos
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999") {
                return false;
            }
            // Valida 1o digito
            add = 0;
            for (let i = 0; i < 9; i++) {
                add += parseInt(cpf.charAt(i)) * (10 - i);
            }
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11) {
                rev = 0;
            }
            if (rev != parseInt(cpf.charAt(9))) {
                return false;
            }
            // Valida 2o digito
            add = 0;
            for (let i = 0; i < 10; i++) {
                add += parseInt(cpf.charAt(i)) * (11 - i);
            }
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11) {
                rev = 0;
            }
            if (rev != parseInt(cpf.charAt(10))) {
                return false;
            }
            return true;
        }
        
        if (validarCPF(value)) {
            return true;
        }
        return 'O campo "{_field_}" não é reconhecido como válido';
    }
});


